import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'

import { useSupportModal } from './support-modal-provider'

export function SupportRouteObserver() {
  const { pathname } = useLocation()
  const { recordRoute } = useSupportModal()

  useEffect(() => {
    recordRoute(pathname)
  }, [pathname, recordRoute])

  return null
}
